import { gsap } from 'gsap'

export const initButtons = () => {
  const buttons = document.querySelectorAll('.button-secondary')
  const maxDistance = 500
  const buttonAnimations = new Map()

  buttons.forEach((button) => {
    const gradientBorder = button.querySelector('.button-gradient')

    const state = {
      centerX: 0.5,
      centerY: 0.5,
      fillPercentage: 30,
      glowIntensity: 0.2,
    }

    buttonAnimations.set(button, {
      state: state,
      animation: null,
    })

    applyGradient(gradientBorder, state)
  })

  let mouseX = window.innerWidth / 2
  let mouseY = window.innerHeight / 2
  let rafId = null

  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX
    mouseY = e.clientY

    if (!rafId) {
      rafId = requestAnimationFrame(updateAllButtons)
    }
  })

  function updateAllButtons() {
    buttons.forEach((button) => {
      updateButtonGradient(button, mouseX, mouseY)
    })
    rafId = null
  }

  function updateButtonGradient(button, mouseX, mouseY) {
    const gradientBorder = button.querySelector('.button-gradient')
    const rect = button.getBoundingClientRect()
    const buttonData = buttonAnimations.get(button)

    const buttonCenterX = rect.left + rect.width / 2
    const buttonCenterY = rect.top + rect.height / 2

    const deltaX = mouseX - buttonCenterX
    const deltaY = mouseY - buttonCenterY
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY)

    const normalizedDistance = Math.min(distance, maxDistance) / maxDistance

    const t = 1 - normalizedDistance
    const easeValue = 0.5 * (t * t * t) + 0.5 * (t * t * t * t * t)
    const fillPercentage = 25 + 75 * easeValue

    const closestX = Math.max(rect.left, Math.min(mouseX, rect.right))
    const closestY = Math.max(rect.top, Math.min(mouseY, rect.bottom))

    const normalizedX = (closestX - rect.left) / rect.width
    const normalizedY = (closestY - rect.top) / rect.height

    const glowIntensity = 0.2 + 0.3 * easeValue

    if (buttonData.animation) {
      buttonData.animation.kill()
    }

    buttonData.animation = gsap.to(buttonData.state, {
      centerX: normalizedX,
      centerY: normalizedY,
      fillPercentage: fillPercentage,
      glowIntensity: glowIntensity,
      duration: 0.6,
      ease: 'power3.out',
      onUpdate: () =>
        applyGradient(gradientBorder, buttonData.state),
    })
  }

  function applyGradient(element, state) {
    let gradientStops = ''
    const numStops = 6
    const primaryColor = [255, 138, 0] // #FF8A00
    const secondaryColor = [255, 94, 3] // #FF5E03

    for (let i = 0; i <= numStops; i++) {
      const percent = (i / numStops) * state.fillPercentage
      const stopPosition = percent.toFixed(2)

      const isEven = i % 2 === 0
      const baseColor = isEven ? primaryColor : secondaryColor

      const opacityFactor = 1 - i / numStops
      const opacity = 1 - 0.9 * (i / numStops)

      gradientStops += `rgba(${baseColor[0]}, ${baseColor[1]}, ${baseColor[2]}, ${opacity}) ${stopPosition}%, `
    }

    gradientStops += `transparent ${(state.fillPercentage + 5).toFixed(2)}%`

    element.style.background = `radial-gradient(circle at ${state.centerX * 100}% ${state.centerY * 100}%, ${gradientStops})`

    element.style.boxShadow = `0 0 15px rgba(255, 94, 3, ${state.glowIntensity})`
  }
}

export default () => {}